export const EVENT_MESSAGE_SENT = '.App\\Modules\\Message\\Logic\\Event\\MessageSent';

export const CHANEL_CHILD_MESSAGE = 'App.Models.Child.';
export const CHANEL_STAFF_MESSAGE = 'App.Models.Staff.';
export const CHANEL_USER = 'App.Modules.User.Persistence.Entity.User.';


export const generateConversationID = (sid, rid) => {
    return [Number(sid), Number(rid)].sort((a, b) => a - b).join('-');
}
